import React from "react"

export default function Card({cardRef, ...props}) {
  let {className, children, ...rest} = props

  if (className == null) className = "da-card"
  else className = `da-card ${className}`

  return <div className={className} ref={cardRef} {...rest}>{children}</div>
}